// One-backend plan step 3, 4b-ii: the World helper card, the only place a helper started from a conversation kept in the
// World is approved (backend lib/gateCatalog.js, step cloud-helper-start/world-helper-start, card world-helper-card-v1). It
// is built only from the call's own arguments, which the approval is bound to: the plain sentence first (with "on World
// credits"), then its name, its first message exactly as the helper gets it, what it runs on and who pays (the World's
// Standard tier, World credits, never the person's own Claude or ChatGPT plan), and that it is started under this
// conversation. A call it cannot show exactly cannot be approved here.

export const START_WORLD_HELPER_TOOL = "neucleos_start_own_session";
export const WORLD_HELPER_RUNS_ON =
  "The World's Standard tier, paid from World credits. Not your own Claude or ChatGPT plan.";
export const WORLD_HELPER_UNDER =
  "This conversation: the helper is a session of yours kept in this World, listed on every screen.";
export const WORLD_HELPER_CARD_BLOCKED =
  "This card cannot show this helper exactly, so it cannot be approved here.";

export interface WorldHelperCard {
  readonly headline: string;
  readonly rows: ReadonlyArray<readonly [label: string, text: string]>;
  readonly blocked: string | null;
}

// A title is one line: the World keeps it trimmed (cleoHelperSessions.js), so the card shows it trimmed, and one with a line
// break, a tab or another control character cannot be shown as one exact line, so it is blocked. The first message is shown
// exactly as the helper gets it, whitespace included (the Codex review of #2473: a trimmed message read differently from the
// helper's own first message, such as indented code).
const CONTROL = /\p{Cc}/u;

/** The card for one start call, or a blocked card when the call is not exactly a helper this card can show. */
export function worldHelperCard(record: Record<string, unknown>): WorldHelperCard {
  const title = typeof record["title"] === "string" ? record["title"].trim() : "";
  const text = typeof record["text"] === "string" ? record["text"] : "";
  if (
    Object.keys(record).some((key) => key !== "title" && key !== "text") ||
    !title ||
    title.length > 160 ||
    CONTROL.test(title) ||
    !text.trim() ||
    text.length > 20000
  )
    return { headline: "Start a helper session on World credits", rows: [], blocked: WORLD_HELPER_CARD_BLOCKED };
  return {
    headline: `Start a helper session, “${title}”, on World credits`,
    rows: [
      ["Name", title],
      ["Its first message", text],
      ["Runs on", WORLD_HELPER_RUNS_ON],
      ["Started under", WORLD_HELPER_UNDER],
    ],
    blocked: null,
  };
}
